import { createFileRoute } from "@tanstack/react-router"

import { AccountIndexRouteComponent } from "@/routes/_authenticated/account/index"

export const Route = createFileRoute("/qr/$qrLookupID/_authenticated/account/")(
  {
    staticData: {
      pageName: "Account",
    },
    component: RouteComponent,
  }
)

function RouteComponent() {
  return <AccountIndexRouteComponent />
}
